/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

const InternalMultiApprovalSuccess = () => {
  const [successPageData, setsuccessPageData] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);

  const [approvedTransactions, setApprovedTransactions] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(disableSwitcher());
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
    } else {
      setsuccessPageData([]);
    }
  }, []);

  const buttonRows = [
    [
      {
        btnText: "Go to approval ",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.GO_TO_APPROVAL,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/internal_transaction_dashboard/internal_transaction_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];
  const buildRows = (txn) => [
    {
      leftTitle: (
        <span className=" font-semibold">
          INR <FormatAmount price={txn?.amount} />
        </span>
      ),
      leftSubTitle: "Amount",
      rightIcon: true,
    },
    {
      leftTitle: formatAccountNumber(txn?.owner_account_bank_acc_no),
      leftSubTitle: "Source account",
      ifsc: txn?.owner_account_ifsc_code,
    },
    {
      leftTitle: formatAccountNumber(txn?.internal_account_bank_acc_no),
      leftSubTitle: "Destination account",
      ifsc: txn?.internal_account_ifsc_code,
    },
  ];

  const TransactionList = ({ transactions }) => (
    <>
      {transactions?.map((txn, i) => (
        <InfoCard
          key={txn?.txn_id || i}
          bgColor="var(--positive-card)"
          hoverable="white"
          showRowDivider={true}
          rowBorderColor="var(--positive-bg)"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={buildRows(txn)}
        />
      ))}
    </>
  );

  const totalTransactions =
    approvedTransactions.length + pendingTransactions.length;

  let titleText = "";

  if (!approvedTransactions.length && pendingTransactions.length) {
    titleText =
      totalTransactions === 1
        ? "Transactions has been approved and pending further approval before distribution."
        : "Transactions have been approved and pending further approval before distribution.";
  } else {
    titleText =
      totalTransactions === 1
        ? "Transaction approved successfully."
        : "Transactions approved successfully.";
  }

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={titleText}
    >
      {!!(pendingTransactions.length && !approvedTransactions.length) && (
        <TabsWeapperSection title={`Pending - ${pendingTransactions.length}`}>
          <TransactionList transactions={pendingTransactions} />
        </TabsWeapperSection>
      )}

      {!!(approvedTransactions.length && !pendingTransactions.length) && (
        <TabsWeapperSection
          title={`Distribution created - ${approvedTransactions.length}`}
        >
          <TransactionList transactions={successPageData} />
        </TabsWeapperSection>
      )}

      {!!(approvedTransactions.length && pendingTransactions.length) && (
        <>
          <TabsWeapperSection
            title={`Distribution created - ${approvedTransactions.length}`}
          >
            <TransactionList transactions={approvedTransactions} />
          </TabsWeapperSection>
          <TabsWeapperSection title={`Pending - ${pendingTransactions.length}`}>
            <TransactionList transactions={pendingTransactions} />
          </TabsWeapperSection>
        </>
      )}
    </StatusContainer>
  );
};

export default InternalMultiApprovalSuccess;
